import {
  CreateBillingPortalResponseForBillingPortal,
  CreateBillingPortalResponseForCheckoutUrl
} from 'services/api/customer/types';

export const isBillingPortalCreateCheckoutResponse = (
  response: CreateBillingPortalResponseForBillingPortal | CreateBillingPortalResponseForCheckoutUrl
): response is CreateBillingPortalResponseForCheckoutUrl => 'checkout_url' in response;
